export enum PermissionAccessLevel {
  VIEW = 0,
  EDIT = 1,
  MANAGMENT = 2
}
